import * as prismic from '@prismicio/client'
import fetch from 'node-fetch'
import config from './config'

export const client = prismic.createClient(config.prismic.api, {
  // If your repository is private, add an access token
  accessToken: config.prismic.accessToken,
  fetch,
})